import { divIcon, LatLngExpression, Marker } from "leaflet";
import { GeometryBarragem } from "../../context";
import { Box, ThemeProvider, Tooltip, Typography, useTheme } from "@mui/material";
import TriangleIcon from "../mapa/icons/triangle";
import { PaintMarker } from "../mapa";

export class GeomBarragem extends Marker<GeometryBarragem> {
  private heightGeom = 50;
  private paintOptions: PaintMarker;

  public properties: GeometryBarragem;

  constructor(latlng: LatLngExpression, properties: GeometryBarragem, paintOptions: PaintMarker) {
    super(latlng, paintOptions);
    this.paintOptions = paintOptions;
    this.properties = properties;

    this.setIcon(divIcon({
      html: this.iconComponent(),
      className: '',
      iconAnchor: [(this.paintOptions.iconSize ?? 20) / 2, this.heightGeom / 2],
    }));

    if (paintOptions.bindTooltip ?? true) {
      this.setIcon(divIcon({
        html: this.iconComponent(),
        className: '',
        iconAnchor: [(paintOptions.iconSize ?? 20) / 2, this.heightGeom / 2],
      }));
    }

    if (paintOptions.bindPopUp ?? true) {
      this.bindPopup(this.popUpComponent(), {
        className: "",
        maxWidth: 390,
        offset: [(paintOptions.iconSize ?? 20) / 2, 0],
      });
    }
  }


  public iconComponent() {
    const component: JSX.Element = (<IconData
      height={this.heightGeom}
      iconSize={this.paintOptions.iconSize ?? 20}
      text={this.properties.tipo}
    />
    );
    return window.JSXToHTML(component);
  }

  public popUpComponent() {
    return window.JSXToHTML(
      <div style={{
        display: "flex",
        flexDirection: "column",
        justifyItems: "center",
        height: "15em",
        width: "27em",
        overflowY: "auto",
      }}>
        <Typography fontSize={"1.2em"} fontWeight={"bold"}>{this.properties.tipo}</Typography>
        <Row title="Finalidade" value={this.properties.finalidade} />
        <Row title="Cota da Crista (m)" value={this.properties.cotaCrista.toSignificantDigits("metric")} />
        <Row title="NA Operacional (m)" value={this.properties.naOperacao.toSignificantDigits("metric")} />
        <Row title="NA Normal (m)" value={this.properties.naNormal.toSignificantDigits("metric")} />
        <Row title="Altura Máx. Barragem (m)" value={this.properties.altMax.toSignificantDigits("metric")} />
        <Row title="Vol. Máx. Reservatório (m³)" value={this.properties.volMax.toSignificantDigits("metric")} />
        <Row title="Vol. Atual Reservatório (m³)" value={this.properties.volAtual.toSignificantDigits("metric")} />
        <Row title="Comprimento da Crista (m)" value={this.properties.compCrista.toSignificantDigits("metric")} />
        <Row title="Largura da Crista (m)" value={this.properties.larguraCrista.toSignificantDigits("metric")} />
        <ClickRow title="Tipo de Seção" value={this.properties.tipoSecao} />
        <ClickRow title="Método de Alteamento" value={this.properties.metodoAltiamento} />
        <ClickRow title="Estrutura Vertente" value={this.properties.estruturaVertente} />
        <ClickRow title="Instrumentação" value={this.properties.instrumentacao} />
      </div>
    );
  }
}

interface PropsIcon {
  text: string;
  height: number;
  iconSize: number;
}
const IconData: React.FC<PropsIcon> = ({ height, iconSize, text }) => {
  const theme = useTheme();
  const contrastText = theme.palette.getContrastText(theme.palette.background.paper);

  return <ThemeProvider theme={theme}>
    <div style={{
      height: `${height}px`,
      width: "250px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    }}>
      <TriangleIcon
        sx={{
          width: `${iconSize}px`,
          height: `${iconSize}px`,
          display: 'inline-block',
          transform: 'rotate(180deg)',
          color: "yellow",
        }}
      />
      <div style={{ width: "5px" }} />
      <Typography
        color="background.paper"
        sx={{ textShadow: `2px 2px 6px ${contrastText}` }}
      >
        {text}
      </Typography>
    </div>
  </ThemeProvider>;
};

interface PropsRow {
  title: string;
  value: string;
}
const Row: React.FC<PropsRow> = (data) => {
  return (
    <div style={{
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      height: "1.5em",
      padding: "5px",
      borderRadius: "5px",
    }}>
      <Typography fontSize={"1em"} fontWeight={"bold"}>{data.title}</Typography>
      <div style={{ minWidth: "5px", flex: 1 }} />
      <Typography fontSize={"1em"}>{data.value}</Typography>
    </div>
  );
};

interface ClcikProps {
  title: string;
  value: string;
}
const ClickRow: React.FC<ClcikProps> = (data) => {
  return (
    <Tooltip title={data.value}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          height: "2.5em",
          overflowX: "clip",
          padding: "5px",
          borderRadius: "5px",
          "&:hover": {
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            cursor: "pointer",
          }
        }}>
        <Typography fontSize={"1em"} fontWeight={"bold"}>{data.title}</Typography>
        <div style={{ minWidth: "5px", flex: 1 }} />
      </Box>
    </Tooltip>
  );
};